export default __webpack_public_path__ + "static/media/about-img.4b3e5bca.jpg";